const common = {
  close: "Close",
  cancel: "Cancel",
  confirm: "Confirm",
  save: "Save",
  delete: "Delete",
  loading: "Loading...",
  error: "Error",
  success: "Success",
  search: "Search...",
  noResults: "No results found",
  retry: "Try again",
  back: "Back",
} as const;
export default common;
